import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { DatePicker } from "antd";
// MOMENT DATE FORMAT
import moment from "moment";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../../../redux/reports/reportsSlice";
// INTERFACES
import { RootState } from "../../../app/store";
import { ReportSliceFiltersInterface } from "../../../interfaces/Reports.interface";

function ReportsFilterDateYear() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { filters, blockFilters } = useSelector((state: RootState) => state.report);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChange = (date: any, dateString: any) => {
    const copy: ReportSliceFiltersInterface = structuredClone(filters);
    copy.startDate = moment()
      .year(parseInt(dateString, 10))
      .startOf("year")

      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    copy.endDate = moment()
      .year(parseInt(dateString, 10))
      .endOf("year")

      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    dispatch(updateFilters(copy));
  };

  const generateDefaultYearDate = () => {
    const copy: ReportSliceFiltersInterface = structuredClone(filters);
    copy.startDate = moment().startOf("year").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    copy.endDate = moment().endOf("year").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    dispatch(updateFilters(copy));
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    generateDefaultYearDate();
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {/** ************************* */}
      {/** BODY */}
      <DatePicker
        picker="year"
        className="generalStyles__width100"
        style={{ height: "24px" }}
        onChange={onChange}
        value={moment(filters.endDate)}
        allowClear={false}
        disabled={blockFilters}
      />
    </div>
  );
}

export default ReportsFilterDateYear;
